import { create } from 'zustand'

interface AppState {
  sidebarOpen: boolean
  selectedApplicationId: string | null
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  setSelectedApplication: (id: string | null) => void
}

export const useAppStore = create<AppState>()((set) => ({
  sidebarOpen: true,
  selectedApplicationId: null,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSelectedApplication: (id) => set({ selectedApplicationId: id }),
}))
